import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

// icons
import TableChartIcon from "@mui/icons-material/TableChart";

// import APIs
import MaterialApi from "../../api/common/Material";
import PrintTypeApi from "../../api/common/PrintType";
import DesignApi from "../../api/common/Design";
import NewBasketApi from "../../api/customer/basket/NewBasket";
import CreateDraftApi from "../../api/customer/draft/Create";
import CalculatePriceApi from "../../api/customer/draft/CalculatePrice";
import AddToBasketApi from "../../api/customer/basket/AddToBasket";

//import UIs
import { ErrorNotify, SuccessNotify } from "../../ui/Toast";
import Autocomplete from "../../ui/formElement/Autocomplete";
import { FromInt, numberSpace } from "../../helpers/NumberTools";
import Button from "@mui/material/Button";

//import modal
import SelectMaterialModal from "../../ui/modals/SelectMaterial";
import TableSizeModal from "../../ui/modals/TableSize";

//import eNums
import sizesEnum from "../../eNums/sizes.enum";
import colorsEnum from "../../eNums/colors.enum";
import printSizeEnum from "../../eNums/printSizes.enum";

import DesignSlider from "../../ui/cards/DesignSlider";

//import skeletons
import DesignSliderSkeleton from "../../ui/skeletons/DesignSlider";

import { setIsLoading, setMetaData } from "../../redux/reducers/page";

const printPlaceOpt = [
  {
    value: "front",
    label: "جلوی تیشرت",
  },
  {
    value: "back",
    label: "پشت تیشرت",
  },
];
const printSizeOpt = Object.keys(printSizeEnum).map((printSize) => {
  return {
    value: printSize,
    label: printSize,
  };
});

const Basket = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [sending, setSending] = React.useState(true);
  const [isLoaded, setIsLoaded] = React.useState(false);
  const [material, setMaterial] = React.useState([]);
  const [printType, setPrintType] = React.useState([]);
  const [design, setDesign] = React.useState(null);
  const [basket, setBasket] = React.useState(null);
  const [price, setPrice] = React.useState(0);

  //  form values
  const [materialId, setMaterialId] = React.useState(null);
  const [size, setSize] = React.useState(null);
  const [color, setColor] = React.useState(null);
  const [printPlace, setPrintPlace] = React.useState(null);
  const [printSize, setPrintSize] = React.useState(null);
  const [colorsOpts, setColorOpts] = React.useState([]);
  const [sizeOpts, setSizeOpts] = React.useState([]);
  const [materialModalOpen, setMaterialModalOpen] = React.useState(false);
  const [tableSizeModalOpen, setTableSizeModalOpen] = React.useState(false);
  const [selectedMaterial, setSelectedMaterial] = React.useState({
    title: "انتخاب نوع تیشرت",
    
  });
  // redux
  const dispatch = useDispatch();
  const { auth } = useSelector((state) => state.customerAuth);

  // find Basket design
  const findDesign = async () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });

    setIsLoaded(false);
    const result = await DesignApi(id);

    if (result.status !== 200) {
      ErrorNotify(JSON.parse(result.response).error);
      navigate(`/`);
      return;
    }
    setDesign(result.data);
    const materialResult = await MaterialApi();
    const materialOpt = materialResult.data.map((material) => {
      return {
        value: material.id,
        material: material,
        label: material.title,
      };
    });

    setMaterial(materialOpt);
    const printTypeResult = await PrintTypeApi();
    setPrintType(printTypeResult.data);
    const basketResult = await NewBasketApi(auth.token);
    setBasket(basketResult.data);
    setIsLoaded(true);
  };

  // add to basket
  const submitForm = async (event) => {
    event.preventDefault();
    if (!materialId) {
      ErrorNotify(" لطفا نوع تیشرت را انتخاب کنید ");
      return;
    }
    if (!color) {
      ErrorNotify(" لطفا رنگ را انتخاب کنید ");
      return;
    }
    if (!size) {
      ErrorNotify(" لطفا سایز را انتخاب کنید ");
      return;
    }
    if (!printPlace) {
      ErrorNotify(" لطفا محل چاپ طرح را انتخاب کنید ");
      return;
    }
    if (!printSize) {
      ErrorNotify(" لطفا اندازه چاپ را انتخاب کنید ");
      return;
    }
    setSending(true);

    const result = await CreateDraftApi(
      auth.token,
      materialId,
      printType[0].id,
      size,
      color,
      design.DesignMedias[0].mediaObj.mediaUrl,
      design.DesignMedias[1].mediaObj.mediaUrl,
      [
        {
          designId: id,
          printPlace,
          printSize,
          width: printSizeEnum[printSize].width,
          height: printSizeEnum[printSize].height,
          xPos: 0,
          yPos: 0,
        },
      ]
    );
    if (result.status === 400) {
      ErrorNotify(" مقادیر به درستی وارد نشده است ");
      setSending(false);
      return;
    }
    if (result.status !== 200) {
      ErrorNotify(JSON.parse(result.response).error);
      setSending(false);
      return;
    }
    if (result.status === 200) {
      await AddToBasketApi(auth.token, result.data.id, basket.id);
      SuccessNotify("سفارش به سبد خرید اضافه شد");
      setSending(false);
      navigate(`/basket`);
      return;
    }
  };
  const calculatePrice = async () => {
    if (!materialId) {
      return;
    }
    if (!color) {
      return;
    }
    if (!size) {
      return;
    }
    if (!printPlace) {
      return;
    }
    if (!printSize) {
      return;
    }
    const result = await CalculatePriceApi(
      auth.token,
      materialId,
      printType[0].id,
      size,
      color,
      design.DesignMedias[0].mediaObj.mediaUrl,
      design.DesignMedias[1].mediaObj.mediaUrl,
      [
        {
          designId: id,
          printPlace,
          printSize,
          width: printSizeEnum[printSize].width,
          height: printSizeEnum[printSize].height,
          xPos: 0,
          yPos: 0,
        },
      ]
    );

    if (result.status === 200) {
      for (let i = 0; i < 80; i++) {
        const p = Math.floor(Math.random() * 120000);
        const t = Math.floor(Math.random() * 900);
        setTimeout(() => setPrice(p), t);
      }
      setTimeout(() => setPrice(result.data - 52962), 1200);
      setTimeout(() => setPrice(result.data + 358620), 1550);
      setTimeout(() => setPrice(result.data), 1800);

      return;
    }
  };
  const selectMaterial = (id) => {
    if (id) {
      const { sizes, colors } = material.find(
        (i) => i.material.id === id
      ).material;
      setColorOpts(
        colors
          .replace(/\s/g, "")
          .replace(/--/g, "-")
          .split("-")
          .map((color) => {
            return {
              value: color,
              label: colorsEnum[color],
            };
          })
      );
      setSizeOpts(
        sizes
          .replace(/\s/g, "")
          .replace(/--/g, "-")
          .split("-")
          .map((size) => {
            return {
              value: size,
              label: sizesEnum[size],
            };
          })
      );
      setSize(null);
      setColor(null);
      setPrintPlace(null);
      setPrintSize(null);
      setMaterialId(id);
    }
  };

  React.useEffect(() => {
    if (printSize) {
      calculatePrice();
      return;
    }
    if (!auth.isAuthenticated) {
      ErrorNotify(" برای ادامه باید وارد شوید ");
      setTimeout(() => {
        navigate(`/login?uri=/basket/${id}`);
        return;
      }, 3000);
    }
    dispatch(
      setMetaData({
        title: "میشرت :  خرید",
        description: "میشرت: خرید",
      })
    );
    dispatch(setIsLoading(false));
    findDesign();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [printSize]);
  return (
    <div className="col-12 col-md-10  col-lg-10 col-xl-10  justify-content-center">
      <div className="row justify-content-center  mb-5 pb-5">
        <div className="col-md-4 col-12">
          <div className="row justify-content-center" dir="ltr">
            {isLoaded ? (
              <div className="col-12">
                <DesignSlider medias={design.DesignMedias} />
              </div>
            ) : (
              <DesignSliderSkeleton />
            )}
          </div>
        </div>
        <div className="col-md-6 col-12">
          <form onSubmit={submitForm}>
            <div className="col-12">
              <div className="col-12 mt-3">
                <Button
                  onClick={() => setMaterialModalOpen(true)}
                  variant="contained"
                  fullWidth={true}
                  color="success"
                >
                  {selectedMaterial.title}
                </Button>
              </div>
              <SelectMaterialModal
                openModal={materialModalOpen}
                setOpenModal={setMaterialModalOpen}
                material={material}
                calculatePrice={calculatePrice}
                selectMaterial={selectMaterial}
                setSelectedMaterial={setSelectedMaterial}
              />
            </div>
            {materialId ? (
              <div className="row m-0 p-0">
                <div className="col-6 ">
                  <Autocomplete
                    options={colorsOpts}
                    name="color"
                    label="رنگ "
                    action={calculatePrice}
                    setValue={setColor}
                  />
                </div>
                <div className="col-6">
                  <Autocomplete
                    options={sizeOpts}
                    name="size"
                    label="سایز تیشرت "
                    action={calculatePrice}
                    setValue={setSize}
                  />
                </div>
                <div className="col-12">
                  <Button
                    onClick={() => setTableSizeModalOpen(true)}
                    variant="outlined"
                    fullWidth={true}
                    startIcon={<TableChartIcon />}
                    color="success"
                  >
                    مشاهده جدول اطلاعات سایز
                  </Button>
                  <TableSizeModal
                    openModal={tableSizeModalOpen}
                    setOpenModal={setTableSizeModalOpen}
                    selectedMaterial={selectedMaterial}
                  />
                </div>
                <div className="col-6">
                  <Autocomplete
                    options={printPlaceOpt}
                    name="printPlace"
                    label="محل چاپ "
                    action={calculatePrice}
                    setValue={setPrintPlace}
                  />
                </div>
                <div className="col-6">
                  <Autocomplete
                    options={printSizeOpt}
                    name="printSizeOpt"
                    label="اندازه چاپ "
                    action={calculatePrice}
                    setValue={setPrintSize}
                  />
                </div>
                <div className="col-12 mt-3">
                  <button
                    disabled={!sending}
                    type="submit"
                    onClick={submitForm}
                    className="btn btn-primary w-100 d-flex justify-content-between align-items-center"
                  >
                    تایید و ادامه
                    <span className="badge badge-warning position-relative sabad_card-totalprice">
                      {FromInt(numberSpace(`${price}`))} تومان{" "}
                    </span>
                  </button>
                </div>
              </div>
            ) : null}{" "}
          </form>
        </div>
      </div>
    </div>
  );
};

export default Basket;
